import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import strings from "translate/language";
import {
  verifyVisitDetail,
  visitorDetail,
} from "reduxStore/action/visitorActions";
import { useDispatch, useSelector } from "react-redux";
import { getAge, handleDetailResponse, hideMobileNumber, isJSON, seo } from "utils/utils";
import { genderCheck } from "utils/constants";
import moment from "moment";
import Breadcrumb from "component/common/breadcrumb";

const ViewVerifyLead = () => {
  const [viewData, setViewData] = useState({});
  const params = useParams();
  const { _id: customer_id } = params || {};
  const lead_id = new URLSearchParams(window.location.search).get("lead_id");

  const dispatch = useDispatch();

  const verifyVisitorDetailSelector = useSelector((state) => state.visitor);

  // useEffect(() => {
  //   dispatch(verifyVisitDetail({ customer_id: customer_id }));
  // }, []);

  useEffect(() => {
    if (lead_id) {
      dispatch(visitorDetail({ lead_id: lead_id }));
    } else {
      dispatch(verifyVisitDetail({ customer_id: customer_id }));
    }
  }, [dispatch, lead_id, customer_id]);

  useEffect(() => {
    if (verifyVisitorDetailSelector.detail) {
      const { response } = verifyVisitorDetailSelector;
      if (response?.status === 200) {
        let office_address = {},
          result = {
            ...handleDetailResponse(response.data),
            ...handleDetailResponse(response.data)?.customer_detail,
          };
        let typeofaddress = typeof result?.office_address;
        if (typeofaddress === "string" || typeofaddress === "object") {
          office_address =
            typeofaddress === "object"
              ? result?.office_address
              : isJSON(result?.office_address) ? JSON.parse(result?.office_address) : null
          // result.customer_detail = { ...result?.customer_detail, office_address: office_address }
        }
        setViewData({ ...result, office_address: office_address });
      }
    }
  }, [verifyVisitorDetailSelector]);

  useEffect(() => {
    seo({
      title: "Verify Visitor Details",
      metaDescription: "Verify visitor details",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.visitorDetails}
        url={"/verify_lead"}
        parentListing={strings.verifyListing}
        titleactive={strings.viewVerifyVisitor}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <h5>{strings.visitorDetails}</h5>
                <div className="card-body">
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.propertyName} :
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.property_title || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.lastInteracted}
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.last_interacted_date
                          ? moment(viewData?.last_interacted_date).format(
                            "DD-MM-yyyy"
                          )
                          : strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />

                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.source} :
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.user_name || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.status} :
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.call_status || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header">
                <h5 className="d-flex justify-content-center">
                  {strings.propertyRequired}
                </h5>
                <div className="card-body">
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.configuration} :
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.configuration || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.Area} :
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.areain_sqlft || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />

                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.budget} :
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.min_budget && viewData?.max_budget
                          ? `${viewData?.min_budget}${viewData?.min_budget_type} - ${viewData?.max_budget}${viewData?.max_budget_type}`
                          : strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.natureOfFunding}
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.funding_type || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.purpose}
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.purpose || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header">
                <h5 className="d-flex justify-content-center">
                  {strings.customerDetails}
                </h5>
                <div className="card-body">
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.visitorName} :
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {`${viewData?.first_name || ""} ${viewData?.last_name || ""}`.trim() || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.mobileNo} :
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.mobile ? hideMobileNumber(viewData?.mobile) : strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.location} :
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.location || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />

                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.age} :
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.birth_date === null
                          ? strings.notavailable
                          : getAge(viewData?.birth_date)}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.gender} :
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {genderCheck[viewData?.gender] || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header">
                <h5 className="d-flex justify-content-center">
                  {strings.companyDetails}
                </h5>
                <div className="card-body">
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.nameOfOccupation}
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.occupation || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.companyName} :
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.coumpany_name || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />

                  <div className="row">
                    <div className=" col-md-3 align-items-center mt-2">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.designation}
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center mt-2">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.desigantion || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center mt-2">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.officeAddress}
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center mt-2">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.customer_detail?.office_address || strings.notavailable}
                      </label>
                    </div>
                    {/* <div className=" col-md-7 align-items-center mt-2">
                      {viewData.office_address ?

                        <label
                          htmlFor="exampleInputMobileNo"
                          className="boldText"
                        >
                          {viewData?.office_address?.house_no}
                          {","}
                          {viewData?.office_address?.area}
                          {","}
                          {viewData?.office_address?.landmark}
                          {","}
                          {viewData?.office_address?.location}
                          {","}
                          {viewData?.office_address?.pincode}
                        </label> : strings.notavailable
                      }

                    </div> */}
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ViewVerifyLead;
